import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step8.sectionTitle',
    defaultMessage:
      'Section 5 - Overseas Emergency Medical or Overseas Emergency Dental Expenses',
  },
  yes: {
    id: 'fastCover.step8.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step8.no',
    defaultMessage: 'No',
  },
  areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses: {
    id:
      'fastCover.step8.areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses',
    defaultMessage:
      'Are you claiming for Overseas Emergency Medical or Dental Expenses?',
  },
  areYouClaimingForOverseas247: {
    id: 'fastCover.step8.areYouClaimingForOverseas247',
    defaultMessage:
      'Are you claiming for Overseas 24/7 Emergency Medical Assistance?',
  },
  areYouClaimingForEmergencyMedicalAndHospitalExpenses: {
    id: 'fastCover.step8.areYouClaimingForEmergencyMedicalAndHospitalExpenses',
    defaultMessage:
      'Are you claiming for Overseas Emergency Medical & Hospital Expenses?',
  },
  areYouClaimingForEmergencyDental: {
    id: 'fastCover.step8.areYouClaimingForEmergencyDental',
    defaultMessage: 'Are you claiming for Overseas Emergency Dental?',
  },
  areYouClaimingForEmergencyEvacuation: {
    id: 'fastCover.step8.areYouClaimingForEmergencyEvacuation',
    defaultMessage: 'Are you claiming for Overseas Emergency Evacuation?',
  },
  areYouClaimingForHospitalCashPayment: {
    id: 'fastCover.step8.areYouClaimingForHospitalCashPayment',
    defaultMessage: 'Are you claiming for Overseas Hospital Cash Payment?',
  },
  areYouClaimingForAccidentalDeath: {
    id: 'fastCover.step8.areYouClaimingForAccidentalDeath',
    defaultMessage: 'Are you claiming for Accidental Death?',
  },
  areYouClaimingForPermanentDisability: {
    id: 'fastCover.step8.areYouClaimingForPermanentDisability',
    defaultMessage: 'Are you claiming for Permanent Disability?',
  },
  areYouClaimingForLossOfIncome: {
    id: 'fastCover.step8.areYouClaimingForLossOfIncome',
    defaultMessage:
      'Are you claiming for Loss of Income?',
  },
  toAssistYourClaim: {
    id: 'fastCover.step8.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.step8.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.step8.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation.',
  },
  document: {
    id: 'fastCover.step8.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.step8.document1',
    defaultMessage:
      'A copy of your Overseas Hospital Admission and Discharge paperwork.',
  },
  document2: {
    id: 'fastCover.step8.document2',
    defaultMessage:
      'Medical reports from the patients Overseas Treating Doctor which confirm the diagnosis and if claiming for loss of income, the period of disablement.',
  },
  document3: {
    id: 'fastCover.step8.document3',
    defaultMessage:
      'Itemised invoices for overseas medical and/or dental expenses claimed – including details of the diagnosis of the medical condition.',
  },
  document4: {
    id: 'fastCover.step8.document4',
    defaultMessage:
      'Receipts for pharmacy expenses and copy of any prescription where possible.',
  },
  document5: {
    id: 'fastCover.step8.document5',
    defaultMessage:
      'Complete and sign the Medical Authority in Section 11 (please note that this should be completed by the person whose illness or injury resulted in this claim or the Executor of the Estate in the event of a death).',
  },
  document6: {
    id: 'fastCover.step8.document6',
    defaultMessage:
      'Please have the patient’s usual treating Doctor or Specialist in Australia complete the Medical Certificate in Section 12.',
  },
  document7: {
    id: 'fastCover.step8.document7',
    defaultMessage:
      'If claiming loss of income, a medical certificate from the patients treating Doctor or Specialist in Australia confirming the diagnosis and ongoing nature of the disablement, including period unable to work.',
  },
  document8: {
    id: 'fastCover.step8.document8',
    defaultMessage:
      'If the claim is as a result of someone’s death, you will need to provide a copy of the death certificate which states the cause of death.',
  },
  document9: {
    id: 'fastCover.step8.document9',
    defaultMessage:
      'A medical certificate from your treating doctor at the time of injury confirming diagnosis and the disablement.',
  },
  document10: {
    id: 'fastCover.step8.document10',
    defaultMessage:
      'A medical certificate from your usual Doctor confirming the diagnosis and ongoing nature of your disablement including period unable to return to work.',
  },
  document11: {
    id: 'fastCover.step8.document11',
    defaultMessage:
      'A letter from your employer stating the date you were due to return to work. (for loss of income claims only)',
  },
  document12: {
    id: 'fastCover.step8.document12',
    defaultMessage:
      'Written evidence of your lost income (last two payslips prior to injury, tax return from last financial year etc.).',
  },
  document13: {
    id: 'fastCover.step8.document13',
    defaultMessage:
      'A medical certificate from your treating doctor at the time of injury confirming diagnosis of the injury',
  },
  document14: {
    id: 'fastCover.step8.document14',
    defaultMessage:
      'A medical certificate from your usual Doctor confirming the diagnosis',
  },
  document15: {
    id: 'fastCover.step8.document15',
    defaultMessage:
      'Written confirmation of the disappearance, sinking or incident report for a cash of the insureds transport provider',
  },
  document16: {
    id: 'fastCover.step8.document16',
    defaultMessage:
      'Written confirmation that the insured has been presumed dead and that their body has not been found within 12 months',
  },
  document17: {
    id: 'fastCover.step8.document17',
    defaultMessage: 'A copy of the insureds death certificate',
  },
  provideExplanation: {
    id: 'fastCover.step8.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  patientName: {
    id: 'fastCover.step8.patientName',
    defaultMessage: "Patient's name",
  },
  relationshipToYou: {
    id: 'fastCover.step8.relationshipToYou',
    defaultMessage: 'Relationship to you',
  },
  patientDateOfBirth: {
    id: 'fastCover.step8.patientDateOfBirth',
    defaultMessage: 'Patients Date of Birth',
  },
  medicareNumber: {
    id: 'fastCover.step8.medicareNumber',
    defaultMessage: 'Medicare number',
  },
  whatIsYourInjuryOrIllness: {
    id: 'fastCover.step8.whatIsYourInjuryOrIllness',
    defaultMessage: 'What was the injury or illness?',
  },
  didThisOccurWhilstEngagingInSnowSportActivity: {
    id: 'fastCover.step8.didThisOccurWhilstEngagingInSnowSportActivity',
    defaultMessage: 'Did this occur whilst engaging in Snow Sport activity?',
  },
  wasTheInufredIllTravallerAnInpatient: {
    id: 'fastCover.step8.wasTheInufredIllTravallerAnInpatient',
    defaultMessage: 'Was the injured/ill traveller an inpatient?',
  },
  dateOfAdmission: {
    id: 'fastCover.step8.dateOfAdmission',
    defaultMessage: 'Date of admission',
  },
  timeOfAdmission: {
    id: 'fastCover.step8.timeOfAdmission',
    defaultMessage: 'Time of admission',
  },
  dateOfDischarge: {
    id: 'fastCover.step8.dateOfDischarge',
    defaultMessage: 'Date of discharge',
  },
  timeOfDischarge: {
    id: 'fastCover.step8.timeOfDischarge',
    defaultMessage: 'Time of discharge',
  },
  nameOfPractitionerDentistHospital: {
    id: 'fastCover.step8.nameOfPractitionerDentistHospital',
    defaultMessage:
      'Name of the overseas medical practitioner, dentist and/or hospital you visited',
  },
  contactEmergencyAssistance: {
    id: 'fastCover.step8.contactEmergencyAssistance',
    defaultMessage: 'Did you contact our Emergency Assistance team?',
  },
  assistanceCaseReferenceNumber: {
    id: 'fastCover.step8.assistanceCaseReferenceNumber',
    defaultMessage: 'Assistance Case Reference Number',
  },
  dateOfFirstMedicalConsultation: {
    id: 'fastCover.step8.dateOfFirstMedicalConsultation',
    defaultMessage: 'Date of first medical consultation',
  },
  hasInjuredOrIllTravellerPreviously: {
    id: 'fastCover.step8.hasInjuredOrIllTravellerPreviously',
    defaultMessage:
      'Has the injured or ill traveller previously suffered from the medical or dental condition which led to this claim?',
  },
  mayNeedInjuredIllPerson: {
    id: 'fastCover.step8.mayNeedInjuredIllPerson',
    defaultMessage:
      'We may need the injured/ill person to complete Section 12, Medical Authority and their usual GP/Specialist to complete Section 13 - Medical Certificate)',
  },
  medicalExpenses: {
    id: 'fastCover.step8.medicalExpenses',
    defaultMessage: 'Medical Expenses',
  },
  medicalExpense: {
    id: 'fastCover.step8.medicalExpense',
    defaultMessage: 'Medical Expense',
  },
  dateOfTreatment: {
    id: 'fastCover.step8.dateOfTreatment',
    defaultMessage: 'Date of treatment',
  },
  nameOfDoctorOrProvider: {
    id: 'fastCover.step8.nameOfDoctorOrProvider',
    defaultMessage: 'Name of Doctor/Dentist/Pharmacy/Hospital or Provider',
  },
  treatmentReceived: {
    id: 'fastCover.step8.treatmentReceived',
    defaultMessage: 'Treatment received',
  },
  amountCharged: {
    id: 'fastCover.step8.amountCharged',
    defaultMessage: 'Amount charged',
  },
  currency: {
    id: 'fastCover.step8.currency',
    defaultMessage: 'Currency',
  },
  didYouPayThisAmount: {
    id: 'fastCover.step8.didYouPayThisAmount',
    defaultMessage: 'Did you pay this amount?',
  },
  refundAmountFromHealthFund: {
    id: 'fastCover.step8.refundAmountFromHealthFund',
    defaultMessage: 'Refund amount from health fund',
  },
  amountClaimed: {
    id: 'fastCover.step8.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  addMedicalExpense: {
    id: 'fastCover.step8.addMedicalExpense',
    defaultMessage: 'Add Medical expense',
  },
  policyMessage: {
    id: 'fastCover.step8.policyMessage',
    defaultMessage:
      'At any point before you purchased your policy and before your departure were you or the person whose illnes or injury resulted in this claim:',
  },
  awareOfAnyMedicalConditions: {
    id: 'fastCover.step8.awareOfAnyMedicalConditions',
    defaultMessage:
      '1. Aware of any medical conditions which could reasonably be expected to give rise to a claim?',
  },
  underInvestigation: {
    id: 'fastCover.step8.underInvestigation',
    defaultMessage:
      '2. Under investigation for an ongoing medical condition by a GP or Specialist? (including undergoing tests whether or not a diagnosis had been made)',
  },
  haveMedicalConditionOrComplication: {
    id: 'fastCover.step8.haveMedicalConditionOrComplication',
    defaultMessage:
      '3. Have any medical condition or complication directly or indirectly related to the medical condition giving rise to this claim?',
  },
  giveATerminalPrognosis: {
    id: 'fastCover.step8.giveATerminalPrognosis',
    defaultMessage:
      '4. Been given a terminal prognosis for their medical condition?',
  },
  travellingAgainst: {
    id: 'fastCover.step8.travellingAgainst',
    defaultMessage:
      '5. Travelling against the advice of a medical practitioner?',
  },
  previousMedicalConditionDetails: {
    id: 'fastCover.step8.previousMedicalConditionDetails',
    defaultMessage: 'Previous medical condition details',
  },
  isRequired: {
    id: 'fastCover.step8.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  medicalExpenseRequired: {
    id: 'fastCover.step8.medicalExpenseRequired',
    defaultMessage: 'Medical Expenses table fields are required fields.',
  },
  plannedReturnToWorkDate: {
    id: 'fastCover.step8.plannedReturnToWorkDate',
    defaultMessage: 'Planned return to work date',
  },
  actualReturnToWorkDate: {
    id: 'fastCover.step8.actualReturnToWorkDate',
    defaultMessage: 'Actual return to work date',
  },
  incomeLost: {
    id: 'fastCover.step8.incomeLost',
    defaultMessage: 'Income lost',
  },
  insuredName: {
    id: 'fastCover.step8.insuredName',
    defaultMessage: "Insured's name",
  },
  insuredDateOfDeath: {
    id: 'fastCover.step8.insuredDateOfDeath',
    defaultMessage: "Insured's Date of Death",
  },
  whatWasTheInjury: {
    id: 'fastCover.step8.whatWasTheInjury',
    defaultMessage: 'What was the injury?',
  },
  other1: {
    id: 'fastCover.step8.other1',
    defaultMessage: 'Medical report from your overseas doctor which confirms the diagnosis',
  },
  other2: {
    id: 'fastCover.step8.other2',
    defaultMessage: 'Discharge summary and admission paperwork (if you were hospitalised overseas)',
  },
  other3: {
    id: 'fastCover.step8.other3',
    defaultMessage: 'Itemised invoices for overseas medical, pharmacy and/or dental expenses claimed',
  },
  other4: {
    id: 'fastCover.step8.other4',
    defaultMessage: 'Any other receipt/proof of payment for the expenses incurred relating to this event happening',
  },
  other5: {
    id: 'fastCover.step8.other5',
    defaultMessage: 'If claiming loss of income due to injury, a medical certificate from the insured’s treating doctor or specialist in Australia confirming the diagnosis, period of inability to work and the ongoing nature of the disablement',
  },
  medicalExpenseWithIdx: {
    id: 'fastCover.step8.medicalExpenseWithIdx',
    defaultMessage: 'Medical Expense {idx}',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step8/messages.js